import { CouponTypeMap } from '../../components/Admin/WatchlistManager/Editors/helpers'
import {
  AllRatingValues,
  CountryCodes,
  CurrencyValues,
  Filter,
  MaturitiesValues,
  Sectors,
  SecurityTypeValues,
  SeriesMap
} from './types'

const sameMembers = (a: readonly unknown[], b: readonly unknown[]) =>
  a.toSorted().join() === b.toSorted().join()

const SCALAR_FIELDS = [
  'price',
  'priceGreaterLessThan',
  'yield',
  'yieldGreaterLessThan',
  'bidAskDiff',
  'bidAskDiffGreaterLessThan',
  'ageOfIssue'
] as const

export const filtersEqual = (filter1: Filter, filter2: Filter) =>
  FilterDefAsArray.every(({ fieldName }) =>
    sameMembers(filter1[fieldName], filter2[fieldName])
  ) && SCALAR_FIELDS.every((field) => filter1[field] === filter2[field])

type FilterField = {
  fieldName: keyof Filter
  sourceValues: string[] | Record<string, string>
}
export const FilterDefAsArray = [
  {
    fieldName: 'sectors',
    sourceValues: Sectors
  },
  {
    fieldName: 'maturities',
    sourceValues: MaturitiesValues
  },
  {
    fieldName: 'securityTypes',
    sourceValues: SecurityTypeValues
  },
  {
    fieldName: 'currencies',
    sourceValues: CurrencyValues
  },
  {
    fieldName: 'ratings',
    sourceValues: AllRatingValues
  },
  {
    fieldName: 'countries',
    sourceValues: CountryCodes
  },
  {
    fieldName: 'couponTypes',
    sourceValues: CouponTypeMap
  },
  {
    fieldName: 'series',
    sourceValues: SeriesMap
  }
] as const satisfies readonly FilterField[]

type EnumeratedFieldType = (typeof FilterDefAsArray)[number]['fieldName']

export const getValueCount = (fieldName: EnumeratedFieldType) => {
  const def = FilterDefAsArray.find((d) => d.fieldName === fieldName)
  if (Array.isArray(def?.sourceValues)) {
    return def?.sourceValues.length
  }
  return def ? Object.values(def?.sourceValues).length : 0
}

export const hasValueInFilter = (filter: Filter) => {
  if (
    FilterDefAsArray.some((d) => {
      const selections = filter[d.fieldName as EnumeratedFieldType]
      return selections.length && selections.length < getValueCount(d.fieldName)
    })
  ) {
    return true
  }
  if (
    [filter.price, filter.yield, filter.bidAskDiff].some((v) => v !== undefined)
  ) {
    return true
  }
  return false
}
